import React, { useState, useEffect, useRef } from "react";
import EditionsData from "./data/editionsData";
import Footer from "./Footer";

function ClassroomEditions() {
  const [activeTab, setActiveTab] = useState(null);
  const [tabSections, setTabSections] = useState([]);
  const contentRef = useRef(null);

  useEffect(() => {
    // Extract the h2 elements
    const h2s = contentRef.current.querySelectorAll("h2");
    const sections = [];

    h2s.forEach((h2) => {
      const title = h2.textContent.trim(); // Get the title from the h2
      const sectionElements = [];

      let el = h2.nextElementSibling;
      while (el && el.tagName !== "H2") {
        sectionElements.push(el.outerHTML); // Get all content until the next h2 tag
        el = el.nextElementSibling;
      }

      sections.push({
        title,
        content: `<h2>${title}</h2>${sectionElements.join("")}`,
      });
    });

    setTabSections(sections);
    if (sections.length > 0) {
      setActiveTab(sections[0].title); // Set the first section as active
    }
  }, []);

  return (
    <div className="container mt-4">
      <h1 className="page-header">Classroom Editions</h1>

      <ul className="nav nav-tabs" role="tablist">
        {tabSections.map((section) => (
          <li
            key={section.title}
            className="tab-item"
            onClick={() => setActiveTab(section.title)}
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            <button
              className={`nav-link ${activeTab === section.title ? "active" : ""}`}
            >
              <i
                className="fa-solid fa-book"
                style={{
                  color: activeTab === section.title ? "#bb4816" : "#000000",
                  marginRight: "5px",
                }}
              ></i>
              {section.title}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content mt-3">
        {tabSections
          .filter((section) => section.title === activeTab)
          .map((section) => (
            <div
              key={section.title}
              className="tab-pane fade active show"
            >
              <div className="bookcovers" dangerouslySetInnerHTML={{ __html: section.content }} />
            </div>
          ))}
      </div>

      <div ref={contentRef} style={{ display: "none" }}>
        <EditionsData />
      </div>

      <Footer />
    </div>
  );
}

export default ClassroomEditions;
